"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TextBadge;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactIntl = require("react-intl");

var _TextBadgeModule = _interopRequireDefault(require("./TextBadge.module.scss"));

var _ETextBadgeTextType = _interopRequireDefault(require("./ETextBadgeTextType"));

var _TextBadge = _interopRequireDefault(require("./TextBadge.i18n"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function TextBadge(_ref) {
  var type = _ref.type,
      text = _ref.text,
      stage = _ref.stage,
      _ref$className = _ref.className,
      className = _ref$className === void 0 ? "" : _ref$className,
      style = _ref.style;

  var _useIntl = (0, _reactIntl.useIntl)(),
      formatMessage = _useIntl.formatMessage; // eslint-disable-next-line complexity


  var getText = (0, _react.useCallback)(function () {
    switch (type) {
      case undefined:
        return text;

      case _ETextBadgeTextType.default.WIN:
        return formatMessage(_TextBadge.default.WIN).toUpperCase();

      case _ETextBadgeTextType.default.LOSE:
        return formatMessage(_TextBadge.default.LOSE).toUpperCase();

      case _ETextBadgeTextType.default.START:
        return formatMessage(_TextBadge.default.START).toUpperCase();

      case _ETextBadgeTextType.default.FAILED:
        return formatMessage(_TextBadge.default.FAILED).toUpperCase();

      case _ETextBadgeTextType.default.VICTORY:
        return formatMessage(_TextBadge.default.VICTORY).toUpperCase();

      case _ETextBadgeTextType.default.STAGE_N_START:
        return formatMessage(_TextBadge.default.STAGE_N_START, {
          n: stage
        });

      case _ETextBadgeTextType.default.LAST_STAGE_START:
        return formatMessage(_TextBadge.default.LAST_STAGE_START);

      case _ETextBadgeTextType.default.STAGE_N_SUCCESS:
        return formatMessage(_TextBadge.default.STAGE_N_SUCCESS, {
          n: stage
        });

      case _ETextBadgeTextType.default.LAST_STAGE_SUCCESS:
        return formatMessage(_TextBadge.default.LAST_STAGE_SUCCESS);

      case _ETextBadgeTextType.default.STAGE_N_FAIL:
        return formatMessage(_TextBadge.default.STAGE_N_FAIL, {
          n: stage
        });

      case _ETextBadgeTextType.default.LAST_STAGE_FAIL:
        return formatMessage(_TextBadge.default.LAST_STAGE_FAIL);

      default:
        throw new Error("Unknown TextBadgeTextType '".concat(JSON.stringify(type), "'."));
    }
  }, [formatMessage, stage, text, type]);
  return /*#__PURE__*/_react.default.createElement("div", {
    "data-text": getText(),
    className: (0, _classnames.default)(_TextBadgeModule.default.badge, className),
    style: style
  }, getText());
}